import { createEvent, sample } from 'effector'
import { fx } from '../../../../libs'
import { $params } from '../../../../features/router'

export const changedEndedStatusMounted = createEvent<{
  winnerTeam: string
}>()

export const changedEndedStatus = fx<
  {
    winnerTeam: string
  },
  void
>({
  method: 'PUT',
  url: `/contest_participant`,
})

sample({
  clock: changedEndedStatusMounted,
  source: $params,
  fn: (params, { winnerTeam }) => {
    let id
    if (params) {
      id = params.demoContestID
    }

    return {
      url: `/contest_team/${id}`,
      body: {
        status: 'results',
        winnerTeam,
      },
    }
  },
  target: changedEndedStatus,
})
